module.exports = __webpack_public_path__ + "kairiceleste.jpg?4c08ddfc1c74eacabc4d8966e340db4d";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/kairiceleste.jpg
// module id = 667
// module chunks = 0